import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DocumentoHabilitacion } from '../../types/DocumentoHabilitacion';

interface DocumentoHabilitacionState {
    documentos: DocumentoHabilitacion[];
    documentoSelected: DocumentoHabilitacion;
    loading: boolean;
}

export const documentoHabilitacionInitial: DocumentoHabilitacion = {
    id: 0,
    idTipoDocumento: 0,
    nombreTipoDocumento: '',
    idHabilitacionContratista: 0,
    fileId: 0,
    subido: false,
    ubicacion: '',
    nombreArchivo: '',
    fechaVencimiento: '',
    formatoArchivo: '',
};

const initialState: DocumentoHabilitacionState = {
    documentos: [],
    documentoSelected: documentoHabilitacionInitial,
    loading: false,
};

export const documentoHabilitacionSlice = createSlice({
    name: 'documentoHabilitacion',
    initialState,
    reducers: {
        isLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
        loadData: (state, data: PayloadAction<DocumentoHabilitacion>): void => {
            state.documentoSelected = data.payload;
            state.loading = false;
        },
        loadList: (state, data: PayloadAction<DocumentoHabilitacion[]>): void => {
            state.documentos = data.payload;
            state.loading = false;
        },
    },
});

export const { isLoading, loadData, loadList } = documentoHabilitacionSlice.actions;
export default documentoHabilitacionSlice.reducer;
